import { loadMoreInit } from "../modules/blog/load-more.js";
import { onDocumentLoaded } from "../utils/on-document-loaded.js";

onDocumentLoaded(() => {
    console.log("[blog-page.js inited]");

    loadMoreInit();
});